export enum LoadTypeEnum {
  TOTAL = "TOTAL",
  DIMENSIONS = "DIMENSIONS",
  BUP = "BUP",
}
